import { render, staticRenderFns } from "./storeItem.vue?vue&type=template&id=667aa82a&scoped=true"
import script from "./storeItem.vue?vue&type=script&lang=js"
export * from "./storeItem.vue?vue&type=script&lang=js"
import style0 from "./storeItem.vue?vue&type=style&index=0&id=667aa82a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667aa82a",
  null
  
)

export default component.exports